<div *ngIf="open" (click)="checkIfNeedsToBeClosed($event, modalBody)">
  <div class="modal">
    <div class="modal-body mpro-box" #modalBody>
      <div class="title-wrapper">
        <div>
          <h3 class="title">{{ title }}</h3>
          <h5 *ngIf="titleInfo" class="title-info">{{ titleInfo }}</h5>
        </div>
        <fa-icon *ngIf="showCloseButton" class="close-button" [icon]="faTimes" (click)="close()"></fa-icon>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
  <div class="modal-background"></div>
</div>
